// src/components/RotaFinanceSummary.jsx


import React from 'react';

const RotaFinanceSummary = ({ totalCost = 0, approvedBudget = 0, predictedCost = 0 }) => {
  const budgetDiff = totalCost - approvedBudget;
  const isOver = budgetDiff > 0;

  return (
    <div className="bg-gray-800 text-white rounded p-6 shadow mt-6 space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-xl font-bold">📊 Financial Summary</h3>
        <span
          className={`px-3 py-1 text-sm rounded-full font-medium ${
            isOver ? 'bg-red-600 text-white' : 'bg-green-700 text-white'
          }`}
        >
          {isOver ? '⚠️ Over Budget' : '✅ Within Budget'}
        </span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-4">
        <div className="bg-gray-900 p-4 rounded shadow text-center">
          <div className="text-sm text-gray-400">Approved Budget</div>
          <div className="text-xl font-semibold text-white">£{approvedBudget.toFixed(2)}</div>
        </div>
        <div className="bg-gray-900 p-4 rounded shadow text-center">
          <div className="text-sm text-gray-400">Total Cost</div>
          <div className="text-xl font-semibold text-white">£{totalCost.toFixed(2)}</div>
        </div>
        <div className="bg-gray-900 p-4 rounded shadow text-center">
          <div className="text-sm text-gray-400">Difference</div>
          <div className={`text-xl font-semibold ${isOver ? 'text-red-400' : 'text-green-400'}`}>
            {isOver ? `-£${budgetDiff.toFixed(2)}` : `£${Math.abs(budgetDiff).toFixed(2)}`}
          </div>
        </div>
      </div>

      {/* 📈 Predicted AI Cost */}
      <div className="text-lg text-blue-400 text-right pr-2 pt-2">
        Predicted Cost: £{predictedCost.toFixed(2)}
      </div>
    </div>
  );
};

export default RotaFinanceSummary;
